// extracted by mini-css-extract-plugin
export default {"mainContent":"NotFoundPage_mainContent__f6h+B","container":"NotFoundPage_container__srPLI","error":"NotFoundPage_error__xAnAw","icon":"NotFoundPage_icon__EmYWx"};